import Parse from 'parse'

const ParseHelper = {}
Parse.CoreManager.set('REQUEST_ATTEMPT_LIMIT', 1)
ParseHelper.install = (Vue, options) => {
  Parse.initialize(options.appId)
  Parse.serverURL = options.url

  Vue.prototype.$parse = () => {
    return Parse
  }
}

export default ParseHelper



// WEBPACK FOOTER //
// ./src/Services/parse/ParseHelper.js